/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
import { orderBy, toLower } from 'lodash';

@Pipe({ name: 'laOrderBy' })
export class OrderByPipe implements PipeTransform {
  transform<T extends Record<string, any>>(items: T[], key: string, asc: 'asc' | 'desc' = 'asc'): T[] {
    return orderBy(items, (item) => toLower(item[key]), [asc]);
  }
}
